$(document).ready(function() {
  if ($('.ph-isOneStore').html() === 'true') {
    $(document).on('click', '.ph-checkout_viewyourcart', function() {
      $('html, body').animate({
        scrollTop: 0
      }, 'slow');
    });
  }
});
